import { Component, OnInit, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'spk-tab-pane',
  templateUrl: './spk-tab-pane.component.html',
  styleUrls: ['./spk-tab-pane.component.scss']
})
export class SpkTabPaneComponent implements OnInit {
  @Input() name: string;
  @Input() active: boolean;
  @Input() class: string;
  constructor() { }

  ngOnInit() {
  }

}
